export const SET_SEARCH_KEY = "packageIdentity/SET_SEARCH_KEY";
export type SET_SEARCH_KEY = typeof SET_SEARCH_KEY;

export const SET_PACKAGE_DISPLAY_DATA = "packageIdentity/SET_PACKAGE_DISPLAY_DATA";
export type SET_PACKAGE_DISPLAY_DATA = typeof SET_PACKAGE_DISPLAY_DATA;

export const SET_PACKAGE_POLL_STATE = "packageIdentity/SET_PACKAGE_POLL_STATE";
export type SET_PACKAGE_POLL_STATE = typeof SET_PACKAGE_POLL_STATE;
